export const defaultPortfolio = {
    "personalInfo": {
        "name": "Sachin Saini",
        "title": "AI Enthusiast | Problem Solver | Builder | Entrepreneurial Thinker",
        "email": "sachinyashpalsinghsaini@gmail.com",
        "phone": "+91-7088892823",
        "location": "Bengaluru, India",
        "linkedin": "https://www.linkedin.com/in/sachin-saini-659846192/",
        "github": "https://github.com/sachinsaini123",
        "website": "https://sachinsaini.dev",
        "bio": "I love solving challenging problems, building impactful products, and exploring the intersection of technology, artificial intelligence, and business. Whether it's architecting scalable systems, experimenting with new ideas, or turning concepts into reality, I'm driven by curiosity, continuous learning, and the desire to create meaningful value.",
        "resumeUrl": "https://drive.google.com/file/d/17lMCnLFWC2OAlFFjWKgH--m_jdQg2JhT/view?usp=sharing",
        "profileSummary": "I'm passionate about solving meaningful problems through technology, building scalable systems, and exploring the possibilities of artificial intelligence.\nOver the past 6+ years, I've worked on distributed systems, cloud-native applications, real-time platforms, and backend architectures across fintech, retail, gaming, and compliance domains. I enjoy turning complex challenges into elegant, reliable solutions that create tangible business impact.\n\nWhat excites me most is the process of building—whether it's architecting a scalable platform, experimenting with AI-driven ideas, automating workflows, or transforming a simple concept into a product that people genuinely find useful.\n\nBeyond my professional work, I'm constantly exploring emerging technologies, learning new concepts, and studying the intersection of technology, business, and innovation. I believe curiosity, continuous learning, and thoughtful execution are the foundations of creating meaningful products and long-term impact."
    },
    "skills": [
        {
            "name": "LLM Application Engineering",
            "level": "Production Experience",
            "category": "innovation",
            "icon": "LLM"
        },
        {
            "name": "AI Agents & Tool Use",
            "level": "Production Experience",
            "category": "innovation",
            "icon": "AG"
        },
        {
            "name": "Prompt Orchestration",
            "level": "Advanced",
            "category": "innovation",
            "icon": "PO"
        },
        {
            "name": "AI Workflow Automation",
            "level": "Production Experience",
            "category": "innovation",
            "icon": "AU"
        },
        {
            "name": "RAG & Context Engineering",
            "level": "Building & Applying",
            "category": "innovation",
            "icon": "RG"
        },
        {
            "name": "AI Evaluation & Observability",
            "level": "Building & Applying",
            "category": "innovation",
            "icon": "EV"
        },
        {
            "name": "Distributed Systems",
            "level": "Core Expertise",
            "category": "engineering",
            "icon": "⚡"
        },
        {
            "name": "Solution Architecture",
            "level": "Core Expertise",
            "category": "engineering",
            "icon": "🏛️"
        },
        {
            "name": "Backend Engineering",
            "level": "Core Expertise",
            "category": "engineering",
            "icon": "🔧"
        },
        {
            "name": "Cloud-Native Systems",
            "level": "Core Expertise",
            "category": "engineering",
            "icon": "☁️"
        },
        {
            "name": "Microservices Architecture",
            "level": "Core Expertise",
            "category": "engineering",
            "icon": "🔄"
        },
        {
            "name": "Node.js",
            "level": "Core Expertise",
            "category": "technology",
            "icon": "JS"
        },
        {
            "name": "TypeScript",
            "level": "Core Expertise",
            "category": "technology",
            "icon": "TS"
        },
        {
            "name": "AWS",
            "level": "Core Expertise",
            "category": "technology",
            "icon": "☁️"
        },
        {
            "name": "Kafka",
            "level": "Advanced",
            "category": "technology",
            "icon": "KF"
        },
        {
            "name": "Redis",
            "level": "Advanced",
            "category": "technology",
            "icon": "RD"
        },
        {
            "name": "MongoDB",
            "level": "Advanced",
            "category": "technology",
            "icon": "DB"
        }
    ],
    "projects": [
        {
            "id": "1",
            "title": "LetsBoostUp",
            "description": "An AI-powered interview preparation platform designed to help software engineers master coding, system design, and technical interviews.",
            "longDescription": "Built a comprehensive interview preparation platform focused on helping engineers accelerate their career growth through structured learning paths, coding practice, system design preparation, AI-assisted guidance, and progress tracking. The platform is designed to provide an organized and personalized interview preparation experience for aspiring and experienced software developers.",
            "technologies": [
                "React",
                "Next.js",
                "Node.js",
                "TypeScript",
                "NestJS",
                "MySQL",
                "MongoDB",
                "Redis",
                "Docker",
                "AWS"
            ],
            "imageUrl": "/letsboostup-logo-approved.png",
            "liveUrl": "https://letsboostup.com",
            "githubUrl": "",
            "featured": true,
            "completed": true,
            "startDate": "2025-06",
            "endDate": "Present"
        },
        {
            "id": "2",
            "title": "Acturum",
            "description": "An AI-powered execution memory platform that turns saved content into concrete, prioritized actions — and drives you to complete them.",
            "longDescription": "Built an AI-powered execution operating system that captures articles, videos, and notes users save, uses AI to summarize, tag, and break them into concrete action items, then delivers a prioritized daily execution list with streak tracking and stale-content alerts. Features Google SSO, a browser extension for one-click capture, and a responsive dark/light mode UI.",
            "technologies": [
                "Next.js",
                "React",
                "Node.js",
                "TypeScript",
                "NestJS",
                "PostgreSQL",
                "Redis",
                "BullMQ",
                "OpenAI",
                "Docker",
                "Vercel",
                "Render"
            ],
            "imageUrl": "/acturum-logo-3d.png",
            "liveUrl": "https://www.acturum.com",
            "githubUrl": "",
            "featured": true,
            "completed": true,
            "startDate": "2025-05",
            "endDate": "Present"
        },
        // {
        //     "id": "2",
        //     "title": "Task Management App",
        //     "description": "A collaborative task management application with real-time updates and team collaboration features.",
        //     "longDescription": "Developed a modern task management app using React, TypeScript, and Firebase. Features real-time collaboration, drag-and-drop task organization, team workspaces, notifications, and mobile-responsive design.",
        //     "technologies": [
        //         "React",
        //         "TypeScript",
        //         "Firebase",
        //         "Tailwind CSS",
        //         "Framer Motion"
        //     ],
        //     "imageUrl": "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=500",
        //     "liveUrl": "https://taskmanager.sachinsaini.dev",
        //     "githubUrl": "https://github.com/sachinsaini/task-manager",
        //     "featured": true,
        //     "completed": true,
        //     "startDate": "2023-03",
        //     "endDate": "2023-05"
        // },
        // {
        //     "id": "3",
        //     "title": "Weather Dashboard",
        //     "description": "A beautiful weather dashboard with detailed forecasts and interactive maps.",
        //     "longDescription": "Created a comprehensive weather dashboard using React and external weather APIs. Features include current weather, 7-day forecasts, interactive maps, location search, and personalized weather alerts.",
        //     "technologies": [
        //         "React",
        //         "JavaScript",
        //         "OpenWeather API",
        //         "Chart.js",
        //         "Mapbox"
        //     ],
        //     "imageUrl": "https://images.unsplash.com/photo-1504608524841-42fe6f032b4b?w=500",
        //     "liveUrl": "https://weather.sachinsaini.dev",
        //     "githubUrl": "https://github.com/sachinsaini/weather-dashboard",
        //     "featured": false,
        //     "completed": true,
        //     "startDate": "2023-01",
        //     "endDate": "2023-02"
        // },
        // {
        //     "id": "4",
        //     "title": "Social Media Analytics",
        //     "description": "Analytics dashboard for social media metrics with data visualization and insights.",
        //     "technologies": [
        //         "Vue.js",
        //         "Python",
        //         "FastAPI",
        //         "PostgreSQL",
        //         "Chart.js"
        //     ],
        //     "imageUrl": "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500",
        //     "githubUrl": "https://github.com/sachinsaini/social-analytics",
        //     "featured": false,
        //     "completed": true,
        //     "startDate": "2022-10",
        //     "endDate": "2022-12"
        // }
    ],
    "experiences": [
        {
            "id": "1",
            "company": "Dataflow Group",
            "position": "Senior Software Development Engineer",
            "location": "Bangalore, India",
            "startDate": "2024-01",
            "current": true,
            "description": [
                "Led a 5-member engineering pod to architect backend microservices for entity onboarding, verification workflow orchestration, and payment lifecycle management — processing ~15,000 verification workflows daily across 30,000+ organizations on AWS (DynamoDB, SQS, SNS, ECS).",
                "Built production AI-powered developer agents adopted by the entire engineering team — including an automated production bug investigator (RCA generation), intelligent code-fix recommender, and token-optimized prompt orchestration engine — reducing mean-time-to-resolution for P1/P2 incidents by ~40%.",
                "Engineered a high-throughput verification allocation engine processing 5,000+ daily task assignments for 1,400+ operations users, using intelligent routing, distributed caching (Redis), optimistic locking, and event-driven state machines to ensure zero-drop reliability.",
                "Designed an event-driven async processing backbone using AWS SNS, SQS, and DLQ-backed consumers with retry/backoff strategies, enabling reliable inter-service communication and reducing end-to-end processing latency by ~50% across payment, verification, and notification pipelines.",
                "Built a centralized SLA monitoring and escalation platform with configurable deadline tracking, automated breach detection, and intelligent notification routing — improving SLA adherence by ~50% across 10+ operational workflows.",
                "Drove production reliability and observability — established structured alerting pipelines, latency tracing, and automated anomaly detection; led production RCAs and implemented systemic fixes that reduced P1 incident recurrence by 80%+."
            ],
            "technologies": [
                "Distributed Systems",
                "Microservices",
                "Event-Driven Architecture",
                "Node.js",
                "TypeScript",
                "AWS",
                "Redis",
                "DynamoDB",
                "Docker",
                "AI/LLM",
                "SQS",
                "SNS",
                "ECS"
            ],
            "companyUrl": "https://www.dataflowgroup.com"
        },
        {
            "id": "2",
            "company": "Arzooo",
            "position": "Software Development Engineer 2",
            "location": "Bangalore, India",
            "startDate": "2022-06",
            "endDate": "2023-12",
            "current": false,
            "description": [
                "Engineered and scaled the Arzooo Pro Retailer Platform with integrated finance, order, and payment modules",
                "Developed retailer onboarding service handling 80K+ merchants including subscription users",
                "Built Central Inventory Service enabling EMI eligibility and higher conversion",
                "Contributed to GoCare warranty system and post-sales customer engagement tools",
                "Developed Kronos dashboard for operational efficiency and reduced developer dependency",
                "Modernized legacy systems by migrating to microservices architecture",
                "Integrated secure PCI-DSS-compliant payment gateways and compliance workflows"
            ],
            "technologies": [
                "NestJS",
                "Express",
                "MongoDB",
                "Redis",
                "Kafka",
                "TypeScript"
            ],
            "companyUrl": "https://www.arzooo.com"
        },
        {
            "id": "3",
            "company": "Moonfrog Labs",
            "position": "Software Development Engineer",
            "location": "Bangalore, India",
            "startDate": "2020-09",
            "endDate": "2022-05",
            "current": false,
            "description": [
                "Developed gameplay mechanics and integrated social features for mobile games using Unity and Cocos2d-x",
                "Led analytics initiatives to monitor engagement and optimize monetization strategies",
                "Orchestrated VIP tournaments with real-time dashboards and leaderboard logic",
                "Built reward-based engagement systems like Reward Ladder to increase session time",
                "Created backend pipelines for real-time player behavior analytics",
                "Scraped geospatial and demographic data to support targeted acquisition campaigns",
                "Collaborated with localization teams to launch culturally tailored game versions"
            ],
            "technologies": [
                "Unity",
                "Cocos2d-x",
                "Node.js",
                "Google Ads",
                "MySQL",
                "Python"
            ],
            "companyUrl": "https://www.moonfroglabs.com"
        }
    ],
    "education": [
        {
            "id": "1",
            "institution": "Indian Institute of Information Technology",
            "degree": "Master of Technology",
            "field": "Computer Science",
            "startDate": "2018-08",
            "endDate": "2020-06",
            "gpa": "8.3"
        }
    ],
    "socialLinks": [
        {
            "platform": "GitHub",
            "url": "https://github.com/sachinsaini123",
            "icon": "github"
        },
        {
            "platform": "LinkedIn",
            "url": "https://www.linkedin.com/in/sachin-saini-659846192/",
            "icon": "linkedin"
        },
        {
            "platform": "Twitter",
            "url": "https://x.com/SACHINS27517281",
            "icon": "twitter"
        },
        {
            "platform": "Email",
            "url": "mailto:sachinyashpalsinghsaini@gmail.com",
            "icon": "email"
        }
    ]
}
